import { useState, useRef, useEffect } from 'react';
import { a as stormDarkTheme, s as stormLightTheme } from '../../../LocalModules/storm-ui-tokens/dist/esm/index-dYroKjHZ.js';
import { T as ThemeModePreference, a as ThemeMode } from './ThemeMode-DBlsP3Iq.js';
import { g as getStoredThemeMode } from './getStoredThemeMode-Dpg19Fxu.js';
import { g as getDarkModeSystemPreference } from './getDarkModeSystemPreference-COXcx2eW.js';
import { B as BROADCAST_CHANNEL_KEY } from '../../constants-BAsg3-1S.js';

/**
 * Hook that returns the effective theme based on the current theme mode (light, dark, or system preference).
 * @param enabled - Whether to calculate and return the theme. If false, returns null to avoid unnecessary processing.
 * @returns The effective theme object with themeMode (resolved light/dark) and themeModePreference (user setting)
 *   properties, or null if disabled.
 */
const useEffectiveTheme = (enabled = true) => {
  const [effectiveThemeMode, setEffectiveThemeMode] = useState(getStoredThemeMode);
  const broadcastChannelRef = useRef(null);
  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof window !== 'undefined') {
      try {
        broadcastChannelRef.current = new BroadcastChannel(BROADCAST_CHANNEL_KEY);
        broadcastChannelRef.current.onmessage = event => {
          const mode = event.data;
          if (mode && Object.values(ThemeModePreference).includes(mode)) {
            setEffectiveThemeMode(mode);
          }
        };
      } catch (error) {
        console.warn('BroadcastChannel API not supported', error);
      }
    }
    return () => {
      if (broadcastChannelRef.current) {
        broadcastChannelRef.current.close();
      }
    };
  }, [enabled]);
  if (!enabled) {
    return null;
  }
  const isDarkMode = effectiveThemeMode === ThemeModePreference.SYSTEM ? getDarkModeSystemPreference() : effectiveThemeMode === ThemeModePreference.DARK;
  const baseTheme = isDarkMode ? stormDarkTheme : stormLightTheme;
  const themeMode = isDarkMode ? ThemeMode.DARK : ThemeMode.LIGHT;
  return {
    ...baseTheme,
    themeMode,
    themeModePreference: effectiveThemeMode
  };
};

export { useEffectiveTheme as u };
//# sourceMappingURL=useEffectiveTheme-CUs9fB0b.js.map
